import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../middleware/dataSlice';

export const fastOutGoingMessagesAPI = createApi({
  reducerPath: 'fastOutGoingMessagesAPI',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    fastoutgoingmessages: builder.mutation<any, any>({
      query: (payload) => ({
        url: '/Process/fastoutgoingmessages',
        method: 'POST',
        body: payload
      }),
    }),

  }),
});
export const {
  useFastoutgoingmessagesMutation
} = fastOutGoingMessagesAPI;
